const TicimaxAttributes = (options) => [
    {
        name: "Name",
        placeholder: "Fahir Özcan",
        value: "fullname",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Email",
        placeholder: "ataturk@turkey.gov.tr",
        value: "email",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "empty"],
    },
    {
        name: "Phone",
        placeholder: "05554443322",
        value: "phone",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Country",
        placeholder: "Türkiye",
        value: "country",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "Türkiye",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: options?.country || [],
    },
    {
        name: "Province",
        placeholder: "İstanbul",
        value: "province",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "İstanbul",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: options?.province || [],
    },
    {
        name: "County",
        placeholder: "Pendik",
        value: "county",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "Pendik",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: options?.county || [],
    },
    {
        name: "Segment",
        placeholder: "active-30",
        value: "segment",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "active-30",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: [
            {
                value: "active-30",
                label: "Active 30",
            },
            {
                value: "active-60",
                label: "Active 60",
            },
            {
                value: "active-90",
                label: "Active 90",
            },
            {
                value: "old-member",
                label: "Old Member",
            },
            {
                value: "lost",
                label: "Lost",
            },
        ],
    },
    {
        name: "Vip",
        placeholder: "Hayır",
        value: "vip",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: false,
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: [
            {
                value: true,
                label: "Evet",
            },
            {
                value: false,
                label: "Hayır",
            },
        ],
    },
    {
        name: "Coupon User",
        placeholder: "Hayır",
        value: "isCouponUser",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: false,
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: [
            {
                value: true,
                label: "Evet",
            },
            {
                value: false,
                label: "Hayır",
            },
        ],
    },
    {
        name: "Took Day From Last Order",
        placeholder: "12",
        value: "tookDayFromLastOrder",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Used Coupon Count",
        placeholder: "1",
        value: "usedCouponCount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Used Coupon Amount",
        placeholder: "40",
        value: "usedCouponAmount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Total Order Count",
        placeholder: "3",
        value: "totalOrderCount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Total Order Amount",
        placeholder: "500",
        value: "totalOrderAmount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Min Order Amount",
        placeholder: "200",
        value: "minOrderAmount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Max Order Amount",
        placeholder: "600",
        value: "maxOrderAmount",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "First Payment Type",
        placeholder: "MultiNet",
        value: "firstPaymentType",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "multinet",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: options?.paymentTypes || [],
    },
    {
        name: "Last Payment Type",
        placeholder: "MultiNet",
        value: "lastPaymentType",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "multinet",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: options?.paymentTypes || [],
    },
    {
        name: "First Source",
        placeholder: "Eski Tadında",
        value: "firstSource",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "ET",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: [
            {
                value: "ET",
                label: "Eski Tadında",
            },
            {
                value: "PA",
                label: "Pazarama",
            },
            {
                value: "HX",
                label: "Hepsi Express",
            },
            {
                value: "TG",
                label: "Trendyol GO",
            },
            {
                value: null,
                label: "Diğer",
            },
        ],
    },
    {
        name: "Last Source",
        placeholder: "Trendyol GO",
        value: "lastSource",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "TG",
        availableOperators: ["equal", "not_equal", "empty"],
        controlType: "select",
        options: [
            {
                value: "ET",
                label: "Eski Tadında",
            },
            {
                value: "PA",
                label: "Pazarama",
            },
            {
                value: "HX",
                label: "Hepsi Express",
            },
            {
                value: "TG",
                label: "Trendyol GO",
            },
            {
                value: null,
                label: "Diğer",
            },
        ],
    },
];

export default TicimaxAttributes;
